<div class="container-fluid">
  <div class="row align-items-center mb-3">
    <div class="col-md-6 d-flex align-items-center gap-2">
      <div class="input-group search-box" style="width: 300px;">
        <span class="input-group-text bg-white border-end-0">
          <i class="bi bi-search text-muted"></i>
        </span>
        <input type="text" class="form-control border-start-0 ps-0" placeholder="Search by description..."
          [(ngModel)]="searchText" (input)="searchByDescriptionEvent($event)" (keyup.enter)="triggerSearch()">
        <button class="btn btn-outline-secondary border-start-0" type="button" *ngIf="searchText" (click)="clearSearch()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <button class="btn btn-primary" (click)="triggerSearch()">Search</button>
    </div>
    <div class="col-md-6 d-flex justify-content-end align-items-center gap-3">
      <app-saved-search #savedSearch [gridApi]="gridApi" [viewFilterType]="viewFilterType" [module]="module" (onClearFilters)="clearFiltersExternally()"></app-saved-search>
      <button class="btn btn-secondary text-white d-flex align-items-center gap-2" (click)="exportCsv()">
        <i class="bi bi-download"></i> Export Csv
      </button>
    </div>
  </div>

  <ag-grid-angular style="width: 100%; height: calc(100vh - 250px);" class="ag-theme-alpine" [gridOptions]="gridOptions"
    [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"
    (dragStopped)="onColumnChange($event)"
    (filterChanged)="onColumnChange($event)"
    (columnVisible)="onColumnChange($event)"
    (sortChanged)="onColumnChange($event)"
    (gridReady)="onGridReady($event)">
  </ag-grid-angular>

</div>